import {FunctionField, ImageField, Show, SimpleShowLayout, TextField} from 'react-admin';
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";

function CityMetaShow(props: any) {
    return (
        <Show {...props} actions={false}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="coordinates.lat" label={'Latitude'} />
                <TextField source="coordinates.long" label={'Longitude'} />
                <ImageField source="image" title="Image" />
                <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTimeWithSeconds(record.createdAt) : '-'} />
                <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTimeWithSeconds(record.updatedAt) : '-'} />
            </SimpleShowLayout>
        </Show>
    )
}

export default CityMetaShow;
